<template>
  <div class="emptyWrapper">
    <div class="emptyIconWrapper">
      <empty-box-icon width="100" height="100"></empty-box-icon>
    </div>
    <div class="emptyTitle">Хоосон байна</div>
  </div>
</template>
<script>
import EmptyBoxIcon from "../components/icons/EmptyBoxIcon.vue";
export default {
  name: "EmptyBox",
  components: { EmptyBoxIcon },
};
</script>
<style scoped>
.emptyWrapper {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 40px 0;
}

.emptyIconWrapper {
  max-width: 100px !important;
  max-height: 100px !important;
}

.emptyTitle {
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: #000000;
  text-align: left;
}
</style>
